import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SchedulerMainComponent } from './pages/scheduler-main/scheduler-main.component';
import { SchedulerNoAuthComponent } from './pages/scheduler-no-auth/scheduler-no-auth.component';
import { EventDetailsComponent } from './components/event-details/event-details.component';
import { ActionButtonsComponent } from './components/action-buttons/action-buttons.component';

const routes: Routes = [
  { path: 'app', component: SchedulerMainComponent },
  { path: 'unauthorized', component: SchedulerNoAuthComponent },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'app'
  },
  {
    path: 'action-buttons', // Path to access the component
    component: ActionButtonsComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
